import React from 'react'
import { LuTarget, LuFlaskConical, LuUsers } from 'react-icons/lu'

const IndustryProgram = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Industry programs</span>
      <h2 className='home_heading'>Bringing industry-aligned programs to educational institutions</h2>
      <p className='home_lead'>We partner with leading industries to develop and deliver curriculum that reflects current trends, emerging technologies, and real-world challenges. Graduates gain the knowledge and skills to transition seamlessly into the workforce.</p>

      <div className='bento'>
        <div className='bento_card'>
          <LuTarget className='bento_icon' />
          <h3 className='bento_title'>Relevant Skills</h3>
          <p className='bento_para'>Equip students with the specific skills required by industries, closing the skills gap and ensuring graduates are work-ready.</p>
        </div>
        <div className='bento_card'>
          <LuFlaskConical className='bento_icon' />
          <h3 className='bento_title'>Practical Application</h3>
          <p className='bento_para'>Integrate real-world projects and case studies into the curriculum, providing hands-on experience and practical application of learned concepts.</p>
        </div>
        <div className='bento_card'>
          <LuUsers className='bento_icon' />
          <h3 className='bento_title'>Industry Mentorship</h3>
          <p className='bento_para'>Connect students with industry professionals who can provide guidance, mentorship, and networking opportunities.</p>
        </div>
      </div>
    </section>
  )
}

export default IndustryProgram
